import(/* webpackMode: "eager" */ "/app/src/app/[locale]/cookie-policy/error.tsx");
